export class MercadoriasDefeitosModel {
  id: number;
  nome_pt: string;
  nome_es: string;
  nome_en: string;
  descricao_pt: string;
  descricao_es: string;
  descricao_en: string;
  observacao_pt: string;
  observacao_es: string;
  observacao_en: string;
  id_mercadoria: number = 0;
  is_indice_acumulado: boolean = false;
  ordem: number = 1;
  id_unidade_medida: number = 0;
}




// WEBPACK FOOTER //
// ./src/app/mercadorias-defeitos/mercadorias-defeitos.model.ts